import axios from "axios";

const PRODUCT_API = "https://japanichiba.duckdns.org/api/v1/home/";
const ADMIN_PRODUCT_API = "https://japanichiba.duckdns.org/api/v1/admin/products";

export const findProductsByName = async (name) => {
    let result = null;
    try {
        if (!name || !name.trim()) return null;

        // Mã hóa ký tự tiếng Việt có dấu trước khi truyền vào query URL
        const encodedName = encodeURIComponent(name.trim());

        result = await axios.get(`${PRODUCT_API}search?keyword=${encodedName}`);
    } catch (e) {
        console.log("Find products API error: " + e);
    }
    return result?.data;
};

export const findProductsById = async (id) => {
    let result = null;
    try {
        result = await axios.get(`${PRODUCT_API}product/${id}`);
    } catch (e) {
        console.log("Find product API error: " + e);
    }
    return result?.data;
};

// ĐÃ SỬA: Trỏ đúng API lấy danh mục ở CategoryController
export const findAllCategory = async () => {
    let result = null;
    try {
        result = await axios.get("https://japanichiba.duckdns.org/api/categories/all");
    } catch (e) {
        console.log("Find categories API error: " + e);
    }
    return result?.data;
};

export const getAllProducts = async (pageNumber = 0, pageSize = 10) => {
    try {
        const response = await axios.get(`${ADMIN_PRODUCT_API}/all`, {
            params: { pageNumber, pageSize }
        });
        return response.data;
    } catch (e) {
        console.error("Lỗi lấy danh sách sản phẩm:", e);
        return null;
    }
};

// ĐÃ SỬA: Đưa categoryId vào DTO gửi lên Server
export const createProduct = async (formDataObj, imageFile) => {
    try {
        const formData = new FormData();

        const productDTO = {
            name: formDataObj.name,
            price: parseFloat(formDataObj.price) || 0,
            stock_quantity: parseInt(formDataObj.stock) || 0,
            description: formDataObj.description || "",
            star: parseFloat(formDataObj.star) || 5,
            categoryId: formDataObj.categoryId ? parseInt(formDataObj.categoryId) : null
        };

        formData.append(
            "product",
            new Blob([JSON.stringify(productDTO)], { type: "application/json" })
        );

        if (imageFile) {
            formData.append("file", imageFile);
        }

        const response = await axios.post(`${ADMIN_PRODUCT_API}/create`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        return response.data;
    } catch (e) {
        console.error("Lỗi thêm sản phẩm:", e);
        throw e;
    }
};

export const deleteProduct = async (id) => {
    try {
        const response = await axios.delete(`${ADMIN_PRODUCT_API}/${id}`);
        return response.data;
    } catch (e) {
        console.error("Lỗi xóa sản phẩm:", e);
        throw e;
    }
};